var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-loading-wrapper"},[_c('div',{staticClass:"full-loading"},[_c('div',{staticClass:"inner-loading"},[_c('img',{attrs:{"src":require("./loading.gif")}}),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }